export default __webpack_public_path__ + "static/blob6-2bb6c27d97e4b2816236272fa65b6ec9.svg";